module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{ errorStatus }}</h4></div><div class=\"modal-body\">{{ errorText }}</div><div class=\"modal-footer\"><button class=\"btn\" ng-click=\"cancel()\">{{ textButton }}</button></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/editor/alert-modal.component.html
// module id = 24
// module chunks = 0